import * as Yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum TagwallPickTicketLineItemKeys {
  lotNumber = 'lotNumber',
  description = 'description',
  qtyOrdered = 'qtyOrdered',
  qtyShipped = 'qtyShipped',
  twNumber = 'twNumber',
  vendor = 'vendor',
}

const TagwallPickTicketLineItemSchema = Yup.object().shape({
  [TagwallPickTicketLineItemKeys.lotNumber]: Yup.string().nullable().optional(),
  [TagwallPickTicketLineItemKeys.description]: Yup.string().nullable().optional(),
  [TagwallPickTicketLineItemKeys.qtyOrdered]: Yup.string().nullable().optional(),
  [TagwallPickTicketLineItemKeys.qtyShipped]: Yup.string().nullable().optional(),
  [TagwallPickTicketLineItemKeys.twNumber]: Yup.string().nullable().optional(),
  [TagwallPickTicketLineItemKeys.vendor]: Yup.string().nullable().optional(),
})

export const tagwallPickTicketFileDataSchema = Yup.object().shape({
  shipTo: Yup.object()
    .shape({
      companyName: Yup.string().nullable().optional(),
      projectDescription: Yup.string().nullable().optional(),
      addressLine1: Yup.string().nullable().optional(),
      addressLine2: Yup.string().nullable().optional(),
      cityStateZip: Yup.string().nullable().optional(),
      phoneNumber: Yup.string().nullable().optional(),
    })
    .required(),
  notes: Yup.string().nullable().optional(),
  transactionNumber: Yup.string().nullable().optional(),
  projectOrJob: Yup.string().nullable().optional(),
  poNumber: Yup.string().nullable().optional(),
  enteredDate: Yup.string().nullable().optional(),
  carrier: Yup.string().nullable().optional(),
  pickUpInstructions: Yup.string().nullable().optional(),
  floor: Yup.string().nullable().optional(),
  projectManager: Yup.object()
    .shape({
      name: Yup.string().nullable().optional(),
      email: Yup.string().nullable().optional(),
      phoneNumber: Yup.string().nullable().optional(),
    })
    .notRequired(),
  projectCoordinator: Yup.object()
    .shape({
      name: Yup.string().nullable().optional(),
      email: Yup.string().nullable().optional(),
      phoneNumber: Yup.string().nullable().optional(),
    })
    .notRequired(),
  items: Yup.array().of(TagwallPickTicketLineItemSchema).required(),
})

export type TagwallPickTicketFileData = Yup.InferType<typeof tagwallPickTicketFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<TagwallPickTicketFileData>

export const tagwallPickTicketFileMappings: RequiredFileData = {
  shipTo: {
    companyName: '9f47c839-15d4-4c3f-b577-169d76cf1234',
    projectDescription: 'e8a12b45-6789-4def-a123-456789abcdef',
    addressLine1: '721ef9d3-4567-4abc-b890-123456789def',
    addressLine2: 'c5d68f12-3456-4789-abcd-ef0123456789',
    cityStateZip: 'b934a7c1-2345-4678-9abc-def012345678',
    phoneNumber: 'f12d45e8-9abc-4def-0123-456789abcdef',
  },
  projectOrJob: '67890abc-def0-4123-4567-89abcdef0123',
  notes: '45678901-2345-4678-9abc-def012345678',
  transactionNumber: '65bbe486-4e41-450d-b28a-ea80a8b09a37',
  pickUpInstructions: '89abcdef-0123-4456-7890-123456789abc',
  poNumber: 'cdef0123-4567-4890-abcd-ef0123456789',
  enteredDate: '34567890-abcd-4ef0-1234-56789abcdef0',
  carrier: '12345678-90ab-4cde-f012-3456789abcde',
  floor: 'f47ac10b-58cc-4372-a567-0e02b2c3d480',
  projectManager: {
    name: 'b8f7e6d5-c4a3-4b2c-9d1e-8f7a6b5c4d40',
    email: 'a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c60',
    phoneNumber: 'f9e8d7c6-b5a4-4c3d-2e1f-0a9b8c7d6e60',
  },
  projectCoordinator: {
    name: '1a2b3c4d-5e6f-4b7c-8d9e-0f1a2b3c4d60',
    email: 'e9d8c7b6-a5f4-4d3c-2e1f-0b9a8c7d6e60',
    phoneNumber: '2b3c4d5e-6f7a-4c8d-9e0f-1a2b3c4d5e60',
  },
  items: [
    {
      lotNumber: '23456789-0abc-4def-0123-456789abcdef',
      description: '90123456-789a-4bcd-ef01-23456789abcd',
      qtyOrdered: '78901234-5678-4abc-def0-123456789abc',
      qtyShipped: 'abcdef01-2345-4678-90ab-cdef01234567',
      twNumber: '56789012-3456-4789-abcd-ef0123456789',
      vendor: '01234567-89ab-4cde-f012-3456789abcde',
    },
  ],
}
